import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Timestamp } from '@dixa/lib-shared-habla';
import { PHONE_BASED_CHANNELS } from 'app/utils/channels';
import { analytics } from 'app/utils/segment';
import { getConversationTitle } from 'components/conversationsOverview/components/ConversationDetails/helpers';
import { ConversationDetailsLayout } from '../../ConversationDetailsLayout';
export const defaultSubTitleRenderer = ({ metaConversation, layout, showMessageCount, }) => {
    var _a, _b, _c;
    const { conversation } = metaConversation;
    const { last_message_created_at: lastMessageCreatedAt } = conversation;
    const { inboundmessagecount: inboundMessageCount, outboundmessagecount: outboundMessageCount, } = conversation;
    const titleStrings = getConversationTitle(metaConversation);
    const { subject } = titleStrings;
    const isSidebarLayout = layout === ConversationDetailsLayout.Sidebar ||
        layout === ConversationDetailsLayout.SidebarCollapsed;
    if (isSidebarLayout && subject) {
        return _jsx(_Fragment, { children: subject });
    }
    const separator = ' · ';
    if (PHONE_BASED_CHANNELS.includes(conversation.initial_channel) &&
        ((_a = conversation.live_assesment) === null || _a === void 0 ? void 0 : _a.is_end_user_connected) &&
        ((_b = conversation.assignment) === null || _b === void 0 ? void 0 : _b.assigned_at)) {
        const assignedAtDate = new Date((_c = conversation.assignment) === null || _c === void 0 ? void 0 : _c.assigned_at);
        return (_jsxs(_Fragment, { children: [!isSidebarLayout && _jsx(_Fragment, { children: "Ongoing: " }), _jsx("span", Object.assign({ onClick: () => analytics.conversationsTimestampClicked({
                        context: 'assigned',
                    }) }, { children: _jsx(Timestamp, { time: assignedAtDate, counter: true, refreshRate: 1000 }) }))] }));
    }
    const CSID = metaConversation.conversation.id;
    const messageCount = (inboundMessageCount !== null && inboundMessageCount !== void 0 ? inboundMessageCount : 0) + (outboundMessageCount !== null && outboundMessageCount !== void 0 ? outboundMessageCount : 0);
    if (CSID || lastMessageCreatedAt) {
        return (_jsxs(_Fragment, { children: [CSID && _jsx("span", { children: `#${CSID}` }), showMessageCount && messageCount > 0 && (_jsxs("span", { children: [separator, `${messageCount} ${messageCount > 1 ? `messages` : `message`}`] })), lastMessageCreatedAt && (_jsxs(_Fragment, { children: [separator, _jsx("span", Object.assign({ onClick: () => analytics.conversationsTimestampClicked({
                                context: 'created',
                            }) }, { children: _jsx(Timestamp, { relative: true, time: lastMessageCreatedAt }) }))] }))] }));
    }
    return null;
};
